import React, { FC } from "react";
import { StyledBtnWrap, StyledEmptySpace } from "./style";
import logo from "../../../assets/images/logo/logo.png";
import { Image } from "../../UI/Image";
import { Typography } from "@mui/material";
import { Button } from "../../UI/Button";

type Props = {
  title: string;
  buttonText?: string;
  buttonEnable: boolean;
  handleButton?: () => void;
  icon?: any;
};

const EmptySpace: FC<Props> = ({
  title,
  buttonText,
  buttonEnable,
  handleButton,
  icon,
}) => {
  return (
    <StyledEmptySpace>
      {/* <Image src={logo} alt="Responsive Images" size="sm" fluid /> */}
      <Typography p="20px">{title}</Typography>
      {buttonEnable && (
        <StyledBtnWrap>
          <Button iconSize="sm" onClick={handleButton}>
            {icon ? icon : null}
            {buttonText}
          </Button>
        </StyledBtnWrap>
      )}
    </StyledEmptySpace>
  );
};

export default EmptySpace;
